import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import JsonLd, { newsArticleLd, breadcrumbLd } from "../components/JsonLd";
import { ArrowLeft, Calendar, ExternalLink } from "lucide-react";

export default function NewsArticle() {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${slug}`).then(({ data }) => setN(data)).catch(() => {}); }, [slug]);

  if (!n) return <div className="hc-container py-20 text-center text-slate-500">Loading…</div>;
  return (
    <>
      <SEO title={n.title} description={n.summary} />
      <JsonLd id="ld-newsarticle" data={newsArticleLd(n)} />
      <JsonLd id="ld-breadcrumb" data={breadcrumbLd([
        { name: "Home", path: "/" },
        { name: "News", path: "/news" },
        { name: n.title, path: `/news/${n.slug}` },
      ])} />
      <div className="hc-container py-10">
        <Link to="/news" className="inline-flex items-center gap-1.5 text-[#0369A1] font-medium text-sm"><ArrowLeft size={16} /> Back to news</Link>
      </div>
      <article className="hc-container max-w-3xl pb-16">
        <div className="text-[12px] text-[#0F766E] font-semibold uppercase tracking-wider flex items-center gap-1.5"><Calendar size={13} /> {n.category} · {n.published_at?.slice(0, 10)}</div>
        <h1 className="font-serif text-3xl md:text-4xl font-semibold text-slate-900 leading-tight mt-3">{n.title}</h1>
        <p className="mt-5 text-slate-700 text-[1.08rem] leading-relaxed">{n.summary}</p>
        {n.image && <img src={n.image} alt={n.title} className="mt-6 rounded-2xl w-full" />}
        <div className="mt-7 prose prose-slate text-slate-700 leading-relaxed whitespace-pre-line text-[16.5px]">{n.content}</div>
        <div className="mt-7 text-[14px] text-slate-500 flex items-center gap-1.5"><ExternalLink size={14} /> Source: {n.source}</div>
      </article>
    </>
  );
}
